import React from "react";

const Services : React.FC = ()  => {
    return(
        <>
            Services        
        </>
    )
}

export default Services